import React from 'react'
import {Link} from 'react-router-dom';

class PackageGridItem extends React.Component<any, any> {
    render () {
        const {item} = this.props
        return (
            <div className='package-detail-grid'>
                <Link to={'/package/detail/' + item.name} >
                    <p className='name'>{item.name}</p>
                    <p className='info'>{item.info || '这是物料的介绍'}</p>
                    <div className='bottom-info1'>
                        <span className='name'>{item.creatorName || <span style={{color: 'red'}}>系统收录</span>}</span>
                        <span className='download'>下载数量: <span>{item.download || 0}</span></span>
                    </div>
                    <div className='bottom-info2'>
                        <span className='version'>version: {item.latestVersion || '--'}</span>
                        <span className='version'>Published: {item.latestTime || '--'}</span>
                    </div>
                </Link>
            </div>
        )
    }
}

export default PackageGridItem
